import * as React from "react";

import { cn } from "@/lib/utils";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[100px] w-full rounded-xl border-[1.5px] border-border bg-background/80 backdrop-blur-md px-4 py-3 text-[1.0625rem] font-normal transition-all duration-200 placeholder:text-muted-foreground focus-visible:outline-none focus-visible:shadow-ios focus-visible:border-primary focus-visible:bg-background disabled:cursor-not-allowed disabled:opacity-40 shadow-ios-sm hover:border-primary/40 hover:shadow-ios resize-none",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
